import { registerComponent } from '@gig/magic-common';
import TextComponent from './text.vue.js';

var Text = registerComponent(TextComponent);

export { Text };
